/*============================================================================
    Start of Slick Carousel Functionality
==============================================================================*/
$(document).ready(function() {
    $('.video-slideshow').slick({
        dots: true,
        speed: 500
    });

    $('.reviews-slideshow').slick({    
        dots: true,
        speed: 500
    });

    $('.artist-slideshow').slick({
        dots: true,
        speed: 500,
        dotsClass: 'slick-dots-2'
    });

    $('.categories-slideshow').slick({
        speed: 500,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: '<span class="next-arrow-container"><i class="fa fa-angle-right next-arrow"></i></span>',
        prevArrow: '<span class="prev-arrow-container"><i class="fa fa-angle-left prev-arrow"></i></span>',

        responsive: [{

        breakpoint: 1200,
        settings: {
            slidesToShow: 3,
        }

        }, {

        breakpoint: 992,
        settings: {
            slidesToShow: 2
        }

        }, {

        breakpoint: 575,
        settings: {
            slidesToShow: 2
        }

        }]
    });

    $('.product-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product-gallery-nav',
        focusOnSelect: false,
        draggable: false
    });

    const slider = $('.product-gallery');
    const zoomBox = $('.product-image-zoom');
    const hoverBox = $('.product-hover-box');
    
    slider.on('mouseenter', 'div', function() {
      const currentSlideIndex = slider.slick('slickCurrentSlide');
      const currentSlide = slider.find('.slick-slide[data-slick-index="' + currentSlideIndex + '"]');
      if (currentSlide[0].nodeName === 'DIV') {
        const imgSrc = currentSlide.find('img').attr('src');
        zoomBox.find('img').attr('src', imgSrc);
        zoomBox.show();
        hoverBox.show();
      }
    });
    
    slider.on('mouseleave', function(event) {
      zoomBox.hide();
      hoverBox.hide();
    });
    
    slider.on('mousemove', function(event) {
      if (event.target.nodeName === 'IMG') {
        const currentSlideIndex = slider.slick('slickCurrentSlide');
        const image = $(this).find('img').eq(currentSlideIndex);
        const zoomedImage = zoomBox.find('img');
        const imageWidth = image.width();
        const imageHeight = image.height();
        const zoomedImageWidth = zoomedImage.width() + 200;
        const zoomedImageHeight = zoomedImage.height() + 200;
        const x = event.pageX - image.offset().left;
        const y = event.pageY - image.offset().top;
        const offsetX = (zoomedImageWidth / 2) - (x / imageWidth * zoomedImageWidth);
        const offsetY = (zoomedImageHeight / 2) - (y / imageHeight * zoomedImageHeight);
        
        zoomedImage.css('transform', `translate(${offsetX}px, ${offsetY}px) scale(2)`);
  
        // update hover box position
        const hoverBoxWidth = 200; // set the width of the hover box
        const hoverBoxHeight = 200; // set the height of the hover box
        const hoverBoxLeft = x - (hoverBoxWidth / 2); // calculate the left position of the hover box
        const hoverBoxTop = y - (hoverBoxHeight / 2); // calculate the top position of the hover box
        
        // limit hover box position to within the image
        const maxLeft = imageWidth - hoverBoxWidth;
        const maxTop = imageHeight - hoverBoxHeight;
        
        hoverBox.css({
          left: Math.min(Math.max(hoverBoxLeft, 0), maxLeft),
          top: Math.min(Math.max(hoverBoxTop, 0), maxTop),
          width: hoverBoxWidth,
          height: hoverBoxHeight,
          display: 'block'
        });
      }
    });

    $('.product-gallery-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-gallery',
        dots: false,
        focusOnSelect: true
    });

    $('.product-gallery-mobile').slick({
        dots: true,
        arrows: false,
        fade: true,
        swipe: false
    });
});